<template>
  <div>
    <h3>Lấy được token</h3>
    <p>{{ token }}</p>
  </div>
</template>
<script>
import { mapActions } from "vuex";

const MS_TOKEN = process.env.VUE_APP_MS_TOKEN_NAME;
const SSO_URL = process.env.VUE_APP_SSO_URL;
const callbackUrl = encodeURI(
  window.location.origin + "/%23%2Fauth%2Flogin%2Fcallback"
);

export default {
  data() {
    return {
      ssoToken: SSO_URL + "go?r=" + callbackUrl,
    };
  },
  computed: {
    token() {
      if (this.$route.query?.tk) {
        this.loginSucess(this.$route.query?.tk);
        return this.$route.query?.tk;
      } else {
        return undefined;
      }
    },
  },
  methods: {
    ...mapActions({
      loginAuth: "auth/login",
    }),
    loginSucess(token) {
      this.loginAuth(this.$route.query?.tk);

      this.$router.push("/");
      this.$notification.success({
        message: "Đăng nhập",
        description: "Bạn đã đăng nhập thành công!",
      });
    },
  },
};
</script>
